module.exports = __webpack_public_path__ + "static/media/7@1024w.0fa57b55.jpg";